import { PictogramVariants } from "src/app/components/Pictogram/Pictogram";
import type { CampaignSuggestions } from "./brief";

export enum FieldType {
  SingleSelect = "singleSelect",
  MultiSelect = "multiSelect",
  AggregatedSelect = "aggregatedSelect",
  Date = "date",
  BoolVal = "boolVal",
  DictionaryElement = "dictionaryElement",
  Rating = "rating",
}

export enum FieldKey {
  Completed = "completed",
  Assignee = "assignee",
  DueDate = "dueDate",
  PublishingDueDate = "Publishing Due Date",
  Title = "title",
}

export enum MetafieldAccessMode {
  write = "write",
  read = "read",
}
export enum MemberWithNotificationType {
  member = "member",
  team = "team",
}

export interface SelectOption {
  backgroundColor: string;
  color: string;
  name: string;
  rank: string;
  value: string;
  icon?: {
    name: string;
    variant: PictogramVariants;
  };
  avatarUrl?: string;
}

export enum MetaFieldDynamicValueProvider {
  SocialProfileValueUpdater = "SocialProfileValueUpdater",
  PublicationValueUpdater = "PublicationValueUpdater",
}

interface AiFileAnalysisAssetQuery {
  assetId: string;
  mimeType: string;
  name: string;
  publicDownloadUrl: string;
  publicPreviewUrl: string;
}

interface AiFileAnalysisAsset {
  fileName: string;
  wsAssetQuery: AiFileAnalysisAssetQuery;
  wsAssetUuid: string;
}

export interface AiFileAnalysis {
  assets: AiFileAnalysisAsset[];
  content: string | null;
  campaign_suggestions: CampaignSuggestions;
}
